import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { Padding } from '../../UI/StyledComponents'
import { TextAreaInput, Button } from '../../UI'
import setByPath from 'lodash/set'
import { graphql, compose } from 'react-apollo'
import ReactStars from 'react-stars'

import LEFT_LOCAL_TOUR_DETAILED_REVIEW from '../../../graphql/Review/LeftLocalTourDetailedReview.graphql'

class LocalTourReview extends Component {
  static propTypes = {}
  constructor(props) {
    super(props)
    this.state = {
      form: {
        description: ''
      },
      communication: 0,
      quality: 0,
      value: 0
    }
  }

  onFormFieldChange(id, value, callback) {
    const form = this.state.form
    const newForm = setByPath(form, id, value)

    this.setState(
      {
        form: newForm
      },
      () => {
        if (callback) {
          callback()
        }
      }
    )
  }
  onStarsSelect(score, name) {
    this.setState({ [name.toLowerCase()]: score }, () => console.log(this.state))
  }

  saveLocalTourReview(data) {
    this.props.leftReview({
      variables: {
        id: this.props.match.params.id,
        quality: this.state.quality,
        communication: this.state.communication,
        value: this.state.value,
        description: this.state.form.description
      }
    })
    console.log(this.props)
  }

  render() {
    const { t } = this.props
    return (
      <div className="container">
        <div className="form-horizontal create-trip__form-container">
          <h2 className="create-trip__form-group-label">{t('description_label')}</h2>
          <div className="reviewform__example ">
            <span>{t('description_example')}</span>
          </div>

          <TextAreaInput
            id="description"
            className="reviewform__textarea"
            maxChars={500}
            placeholder={t('description_placeholder')}
            onChangeExternal={(id, props) => this.onFormFieldChange(id, props)}
          />

          <div className="reviewform__qualities">
            {['Communication', 'Quality', 'Value'].map((el, key) => {
              return (
                <div className="stars" key={key}>
                  <p className="create-trip__form-group-label ">{el}: </p>

                  <ReactStars
                    key={el}
                    value={this.state[el.toLowerCase()]}
                    count={5}
                    onChange={e => {
                      this.onStarsSelect(e, el)
                    }}
                    size={23}
                    edit={true}
                    color1={'#e1e2df'}
                    color2={'#33b3de'}
                    half={false}
                  />
                  <div className="arrow_box">Click to rate</div>
                </div>
              )
            })}
          </div>

          <div className="row reviewform__text">
            <div className="col-md-12 text-center">
              <div>
                <p>
                  {t('text_p1')}
                  {!!this.props.user ? this.props.user.userProfile.firstName : ''}
                  {t('text_p2')}
                </p>
              </div>
              <div>
                <p>{t('agriment')}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 text-center">
            <Button
              name={t('save')}
              onSubmit={() => {
                this.saveLocalTourReview(this.state.form)
                this.props.history.goBack()
              }}
              className="btn create-trip__submit-btn"
            />
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(
  graphql(LEFT_LOCAL_TOUR_DETAILED_REVIEW, {
    name: 'leftReview',
    options: {
      fetchPolicy: 'no-cache'
    }
  }),
  translate('localTour_review', {
    withRef: true
  })
)
export default enhance(LocalTourReview)



// WEBPACK FOOTER //
// src/components/Rewiev/LocalTourReview/LocalTourReview.js